import React, { Component } from 'react';
import CustomTask from '../CustomTask';
import { isObjectValuesFalsy } from '../../../utils/validation';

import { navigateToStages } from './navigateToStages';
import {
  navigateToSummary,
  navigateToSummaryNoQuery
} from './navigateToSummary';

class NavigationWrapper extends Component {
  state = {};

  setInvalidDocumentsError = (documents, message) => {
    const { setTaskValues, setErrorMessage } = this.props;
    if (/\[.*[0-9]+.*\]/.test(documents)) {
      setTaskValues({
        errorDocuments: documents
          .trim()
          .slice(1, -1)
          .split(', ')
      });
    }
    setErrorMessage(message + ':' + documents);
  };

  get navigationValues() {
    const {
      currentStage,
      currentSection,
      stages,
      sections
    } = this.props.taskValues;
    return {
      currentStageIndex: stages.findIndex(stage => stage === currentStage),
      currentSectionIndex:
        sections && sections.findIndex(section => section === currentSection),
      lastSection: sections && sections[sections.length - 1] === currentSection
    };
  }

  handleBack = () => {
    const {
      taskValues,
      clearTaskValues,
      handleBackToTasks,
      setTaskValues
    } = this.props;
    const {
      currentStage,
      currentSection,
      sectionsData,
      stages,
      sections
    } = taskValues;
    const {
      currentStageIndex,
      currentSectionIndex,
      lastSection
    } = this.navigationValues;
    let newCurrentStage = currentStage;
    let newCurrentSection = currentSection;
    if (lastSection && !sectionsData[currentStage]) {
      newCurrentStage = stages[currentStageIndex - 1];
    } else {
      newCurrentSection = sections && sections[currentSectionIndex - 1];
      if (
        !newCurrentSection ||
        (newCurrentSection && !sectionsData[currentStage][newCurrentSection])
      ) {
        newCurrentStage = stages[currentStageIndex - 1];
      }
    }
    if (currentStageIndex > 0) {
      setTaskValues({
        currentStage: newCurrentStage,
        currentSection: newCurrentSection
      });
    } else {
      clearTaskValues();
      handleBackToTasks();
    }
  };

  handleNext = data => {
    const { setTaskValues, taskType, taskValues } = this.props;
    const { currentStage, currentSection, stages, sectionsData } = taskValues;
    const { currentStageIndex, lastSection } = this.navigationValues;
    const summaryParams = [
      this.props,
      this.showConfirmModal,
      this.hideConfirmModal,
      this.setInvalidDocumentsError
    ];

    if (currentStageIndex === 0) {
      return this.navigateToDocuments('passengers');
    }
    if (currentStageIndex === 1) {
      return navigateToStages(this.props, this.setInvalidDocumentsError);
    }
    if (currentStage === 'airRefund attachments') {
      return this.navigateToDocuments('court');
    }
    if (currentStage === 'court attachments') {
      return navigateToSummary(...summaryParams);
    }
    if (currentStageIndex > 1 && currentStageIndex < stages.length - 1) {
      if (data) {
        setTaskValues({
          sectionsData: {
            ...sectionsData,
            [currentStage]: {
              ...sectionsData[currentStage],
              [currentSection]: {
                ...sectionsData[currentStage][currentSection],
                template: data
              }
            }
          }
        }).then(() => {
          if (taskType === 'LFN' && lastSection) {
            return navigateToSummary(...summaryParams);
          } else if (taskType === 'CA' && lastSection) {
            return this.navigateToDocuments('airrefund');
          }
          return navigateToStages(this.props, this.setInvalidDocumentsError);
        });
      }
    }
  };

  navigateToDocuments = type => {
    const {
      taskValues: { options, stages },
      setErrorMessage,
      setTaskValues
    } = this.props;

    switch (type) {
      case 'airrefund':
        return setTaskValues({ currentStage: stages[stages.length - 3] });
      case 'court':
        return setTaskValues({ currentStage: stages[stages.length - 2] });
      default:
        const {
          rulesForFinancialRequestOption: ignored,
          ...restOptions
        } = options;
        if (!isObjectValuesFalsy(restOptions)) {
          return setTaskValues({
            currentStage: stages[1]
          });
        }
        return setErrorMessage('You must fill all fields completely.');
    }
  };

  showConfirmModal = () => this.setState({ confirmForceModalVisible: true });
  hideConfirmModal = () => this.setState({ confirmForceModalVisible: false });

  navigateToSummaryNoQuery = () => {
    const {
      setTaskValues,
      taskValues: { stages }
    } = this.props;
    navigateToSummaryNoQuery(setTaskValues, stages, this.hideConfirmModal);
  };

  navigateToSummary = () => {
    return navigateToSummary(
      this.props,
      this.showConfirmModal,
      this.hideConfirmModal,
      this.setInvalidDocumentsError,
      true
    );
  };

  render = () => {
    const {
      taskValues: { errorDocuments }
    } = this.props;
    const disabledNext = errorDocuments && errorDocuments.length > 0;
    return (
      <CustomTask
        {...this.props}
        handleBack={this.handleBack}
        handleNext={this.handleNext}
        disabledNext={disabledNext || false}
        navigateToSummary={this.navigateToSummary}
        navigateToSummaryNoQuery={this.navigateToSummaryNoQuery}
        confirmForceModalVisible={this.state.confirmForceModalVisible}
      />
    );
  };
}

export default NavigationWrapper;



// WEBPACK FOOTER //
// ./src/component/TaskCreator/NavigationWrapper/index.js